// Nome dos recursos do react-admin usado em título de página.
// Sem isto o react-admin mostra o nome técnico ("Chains", "Employees") — hoje é
// assim também em português; aqui só corrigimos o espanhol.
const resources = {
    chains: { name: 'Red |||| Redes' },
    employees: { name: 'Empleado |||| Empleados' },
    'chains/chainId/reports/coupons': { name: 'Reporte de cupones' },
    discounts: { name: 'Descuento |||| Descuentos' },
};

export default resources;
